import { useMutation } from '@tanstack/react-query';
import {
  DEMO_FILL_FORM_FROM_UPLOAD_MUTATION_KEY,
  type FillFormDemoFromUploadRequest,
  type FillFormDemoResponse,
} from '../../contracts';
import { fillFormDemoFromUpload } from '../api/templates';

export function useMutateFillFormDemoFromUpload() {
  return useMutation<FillFormDemoResponse, Error, FillFormDemoFromUploadRequest>({
    mutationKey: DEMO_FILL_FORM_FROM_UPLOAD_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillFormDemoFromUpload(request);
      return data;
    },
  });
}
